import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { OpenIDConnectService } from '@services/auth/openid-connect.service';
import * as Highcharts from 'highcharts';

// This prevents error: "Highcharts not defined"
// https://github.com/highcharts/highcharts/issues/4994
// @ts-ignore
window.Highcharts = Highcharts;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'DepositAnalyticsWEB';

  get isLoggedIn() {
    return this.auth.userAvailable && !this.auth.user.expired;
  }

  get isErrorRoute() {
    return this.router.url.includes('error');
  }

  constructor(private readonly auth: OpenIDConnectService, private readonly router: Router) {}
}
